<template>
  <v-col
    v-if="!isReportNumber"
    :style="{maxWidth: `${cellWidth}px`}"
    class="font-weight-bold pa-4"
  >
    {{ cellValue }}
  </v-col>
  <v-col
    v-else
    :style="{maxWidth: `${cellWidth}px`}"
    class="font-weight-bold text-right pa-4"
  >
    <ReportNumber :value="cellValue" />
  </v-col>
</template>
<script>
import ReportNumber from "@/components/ReportNumber.vue";
export default {
  components: {
    ReportNumber,
  },
  props: ["isReportNumber", "cellValue", "cellWidth"],
};
</script>